export default "__VITE_ASSET__d9216d73__"